import script from "./FormDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./FormDescription.vue?vue&type=script&setup=true&lang=js"

import "./FormDescription.vue?vue&type=style&index=0&id=46ec9618&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46ec9618"]])

export default __exports__